import { render } from "./PageHeader.vue?vue&type=template&id=29a35716&ts=true"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"

import "./PageHeader.vue?vue&type=style&index=0&id=29a35716&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__